import { getMicroserviceBaseContext } from '../../constants/api-routing';

const notificationsContext = getMicroserviceBaseContext('notifications');

export const NOTIFICATION_SERVICE = {
    emailList: `${notificationsContext}list_email_template`,
    createEmail: `${notificationsContext}create_email_template`,
    updateEmail: `${notificationsContext}update_email_template`,
    deleteEmail: `${notificationsContext}delete_email_template`,
    getEmail: `${notificationsContext}get_email_template`,
}
